// Zusatz-Logik zum Customizer (isoliert von custom-designer.js)
//
//   A) Stickoptik-Vorschau: Klick auf eine KI-Kachel zeigt sofort das
//      Linienmotiv und tauscht es dann gegen die Stickoptik.
//   B) Einheitliche Motiv-Groesse: Das SICHTBARE Motiv wird immer gleich
//      gross dargestellt — unabhaengig von Dateiformat, Seitenverhaeltnis
//      und leerem Rand der Datei.
//
// custom-designer.js wird bewusst nicht angefasst.
//
// Diagnose: URL um ?laurellesDebug ergaenzen -> Messwerte in der Konsole.

(function () {
  'use strict';

  var BASE = window.LAURELLES_AI_BACKEND_URL || '';
  var DEBUG = /laurellesDebug/.test(location.search);

  function vorschauBild() { return document.getElementById('liveImagePreview'); }
  function log() { if (DEBUG && window.console) console.log.apply(console, ['[Motivgroesse]'].concat([].slice.call(arguments))); }

  // ===========================================================================
  // A) Stickoptik-Vorschau
  // ===========================================================================

  var stickCache = {};
  var laufendeAuswahl = 0;

  function zeigeStick(url, meine) {
    if (meine !== laufendeAuswahl) return;
    var img = vorschauBild();
    if (!img || img.style.display === 'none') return;
    img.src = url;
  }

  document.addEventListener('click', function (evt) {
    var kachel = evt.target && evt.target.closest ? evt.target.closest('.ai-choice') : null;
    if (!kachel || !BASE) return;
    var imageId = kachel.dataset.imageId;
    if (!imageId) return;

    laufendeAuswahl++;
    var meine = laufendeAuswahl;

    var img = vorschauBild();
    if (img) img.style.mixBlendMode = 'normal';

    if (stickCache[imageId]) { zeigeStick(stickCache[imageId], meine); return; }

    fetch(BASE + '/api/ai/embroider', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ image_id: imageId })
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.preview_url) return;
        stickCache[imageId] = d.preview_url;
        var vor = new Image();
        vor.onload = function () { zeigeStick(d.preview_url, meine); };
        vor.src = d.preview_url;
      })
      .catch(function () { /* Stickoptik ist Kuer */ });
  });

  // ===========================================================================
  // B) Einheitliche Motiv-Groesse
  // ===========================================================================
  //
  // custom-designer.js skaliert auf die DATEIBREITE. Dadurch erscheint
  // dasselbe "Mittel" je nach Datei voellig unterschiedlich gross: ein
  // breiter Schriftzug wird winzig, ein Motiv mit viel Rand ebenso.
  //
  // Hier zaehlt stattdessen die Bounding-Box des sichtbaren Inhalts. Sie
  // wird als ANTEIL der Bildflaeche gemessen (nicht in Pixeln) — dadurch
  // funktioniert es auch fuer SVG, das keine feste Pixelgroesse hat.
  //
  // Zwei Fallen, die hier bewusst umgangen werden:
  //  1. createImageBitmap unterstuetzt KEIN SVG -> Messung schlug bei
  //     SVG-Uploads still fehl (Laura 2026-08-18). Deshalb <img> + Canvas.
  //  2. Bei SVG ohne feste Groesse meldet der Browser ein falsches
  //     Seitenverhaeltnis -> das Bild wuerde verzerrt. Deshalb bekommt das
  //     Vorschaubild 'object-fit: contain' und eine feste Box: dann rendert
  //     der Browser exakt so wie die Messung (mit Rand statt Verzerrung).

  var MESSRASTER = 400;
  var boxCache = {};
  var setzeGerade = false;

  function produktBild() {
    return document.querySelector('.product__media img')
        || document.querySelector('.product__main-photos img')
        || document.querySelector('.product-single__photo img')
        || document.querySelector('[data-product-featured-image]')
        || document.querySelector('.product__image img');
  }

  function zielPixel() {
    var feld = document.getElementById('widthMmInput');
    if (!feld) return 0;
    var widthMm = parseFloat(feld.value);
    if (!widthMm) return 0;

    var cfg = window.LAURELLES_CUSTOMIZER_CONFIG;
    var breiteCm = (cfg && cfg.tshirt_width_cm > 0) ? cfg.tshirt_width_cm : 48;

    var haupt = produktBild();
    if (!haupt) return 0;
    var gerendert = haupt.clientWidth || haupt.offsetWidth
                 || (haupt.getBoundingClientRect && haupt.getBoundingClientRect().width);
    if (!gerendert || gerendert < 50) return 0;

    return (widthMm / 10) * (gerendert / breiteCm);
  }

  // Liefert Anteile (0..1) der Messbox: {fx, fy, fw, fh, verhaeltnis}
  function messeMotiv(src) {
    if (boxCache[src]) return Promise.resolve(boxCache[src]);

    return new Promise(function (resolve, reject) {
      var im = new Image();

      // Bilder von api.laurelles.de sind fremde Herkunft — ohne dies waere
      // die Canvas gesperrt und nicht auslesbar. CORS-Freigabe fuer
      // /api/ai/* liegt im Backend.
      if (src.indexOf('data:') !== 0 && src.indexOf(location.origin) !== 0) {
        im.crossOrigin = 'anonymous';
      }

      im.onerror = function () { reject(new Error('Bild nicht ladbar')); };
      im.onload = function () {
        try {
          var nw = im.naturalWidth || MESSRASTER;
          var nh = im.naturalHeight || MESSRASTER;
          var verhaeltnis = nw / nh;

          var cw = MESSRASTER, ch = MESSRASTER;
          if (verhaeltnis >= 1) { ch = Math.max(1, Math.round(MESSRASTER / verhaeltnis)); }
          else { cw = Math.max(1, Math.round(MESSRASTER * verhaeltnis)); }

          var c = document.createElement('canvas');
          c.width = cw; c.height = ch;
          var ctx = c.getContext('2d', { willReadFrequently: true });
          ctx.drawImage(im, 0, 0, cw, ch);
          var daten = ctx.getImageData(0, 0, cw, ch).data;

          // Echte Transparenz vorhanden? Dann zaehlt der Alpha-Kanal,
          // sonst gilt "nicht nahezu weiss" als Inhalt.
          var hatAlpha = false;
          for (var p = 3; p < daten.length; p += 4) {
            if (daten[p] < 250) { hatAlpha = true; break; }
          }

          var minX = cw, minY = ch, maxX = -1, maxY = -1;
          for (var y = 0; y < ch; y++) {
            for (var x = 0; x < cw; x++) {
              var i = (y * cw + x) * 4;
              var inhalt;
              if (hatAlpha) {
                inhalt = daten[i + 3] > 24;
              } else {
                inhalt = (0.299 * daten[i] + 0.587 * daten[i + 1] + 0.114 * daten[i + 2]) < 245;
              }
              if (inhalt) {
                if (x < minX) minX = x;
                if (x > maxX) maxX = x;
                if (y < minY) minY = y;
                if (y > maxY) maxY = y;
              }
            }
          }

          if (maxX < 0) { minX = 0; minY = 0; maxX = cw - 1; maxY = ch - 1; }

          var box = {
            fx: minX / cw,
            fy: minY / ch,
            fw: (maxX - minX + 1) / cw,
            fh: (maxY - minY + 1) / ch,
            verhaeltnis: verhaeltnis
          };
          log('gemessen', src.slice(0, 60), box);
          boxCache[src] = box;
          resolve(box);
        } catch (e) {
          reject(e);
        }
      };

      im.src = src;
    });
  }

  function normalisiere() {
    var img = vorschauBild();
    if (!img || !img.src || img.style.display === 'none') return;

    var ziel = zielPixel();
    if (!ziel) return;

    var src = img.src;
    messeMotiv(src).then(function (box) {
      var aktuell = vorschauBild();
      if (!aktuell || aktuell.src !== src) return;

      // Box (W x H) so waehlen, dass die LAENGERE Seite des sichtbaren
      // Motivs exakt der gewaehlten Groesse entspricht:
      //   sichtbare Breite = fw * W
      //   sichtbare Hoehe  = fh * H,  H = W / verhaeltnis
      var nenner = Math.max(box.fw, box.fh / box.verhaeltnis);
      if (!nenner || !isFinite(nenner) || nenner <= 0) return;

      var W = ziel / nenner;
      var H = W / box.verhaeltnis;
      if (!isFinite(W) || !isFinite(H) || W <= 0 || H <= 0) return;

      // Motivmitte auf den Anker schieben (sonst zieht einseitiger Rand
      // das Motiv aus der Position)
      var dx = ((box.fx + box.fw / 2) - 0.5) * W;
      var dy = ((box.fy + box.fh / 2) - 0.5) * H;

      setzeGerade = true;
      aktuell.style.setProperty('width', W + 'px', 'important');
      aktuell.style.setProperty('height', H + 'px', 'important');
      aktuell.style.setProperty('max-width', 'none', 'important');
      aktuell.style.setProperty('max-height', 'none', 'important');
      // Verhindert Verzerrung, falls der Browser das Seitenverhaeltnis der
      // Datei falsch meldet (haeufig bei SVG ohne width/height-Attribut).
      aktuell.style.setProperty('object-fit', 'contain', 'important');
      aktuell.style.transform = 'translate(-50%, -50%) translate(' + (-dx) + 'px, ' + (-dy) + 'px)';
      log('gesetzt', { ziel: Math.round(ziel), W: Math.round(W), H: Math.round(H) });
      setTimeout(function () { setzeGerade = false; }, 0);
    }).catch(function (e) {
      log('Messung fehlgeschlagen — Standard-Skalierung bleibt', e && e.message);
    });
  }

  function starte() {
    var img = vorschauBild();
    if (!img) { setTimeout(starte, 300); return; }
    if (img.dataset.groesseAktiv) return;
    img.dataset.groesseAktiv = '1';

    new MutationObserver(function () {
      if (setzeGerade) return;
      normalisiere();
    }).observe(img, { attributes: true, attributeFilter: ['src', 'style'] });

    document.addEventListener('laurelles:sizeStepChanged', function () { setTimeout(normalisiere, 10); });
    window.addEventListener('resize', function () { setTimeout(normalisiere, 100); });
    setTimeout(normalisiere, 600);
    log('aktiv');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', starte);
  } else {
    starte();
  }
  window.addEventListener('load', starte);
})();
